export const getOrderStatusColor = (orderStatus?: string | null): string => {
  switch (orderStatus) {
    case 'OC-Draft':
    case 'OC-New':
    case 'OC-Updated':
    case 'OC-New/Updated':
    case 'IM-Recycle':
    case 'MOT-Recycle':
    case 'MOT-Revised':
    case 'SP-Recycle':
      return '#FFCF01';

    case 'IM-Reject':
    case 'MOT-Rejected':
    case 'SP-Rejected':
    case 'OC-Cancelled':
      return '#FE000C';

    case 'IM-Confirmed':
    case 'IM-Confirmed w/o RC':
      return '#00BCE4';

    case 'MOT-Pending carrier':
    case 'MOT-Scheduled':
    case 'MOT-Scheduled/updated':
      return '#74195E';

    case 'SP-Loaded':
    case 'SP-Confirmed':
    case 'SP-Received':
      return '#00A160';

    default:
      return 'black';
  }
};
